module.exports = __webpack_public_path__ + "static/media/footer_iecas.fd40d065.jpg";